import { render, staticRenderFns } from "./documento_encaminhamento.vue?vue&type=template&id=468589fb&scoped=true&"
import script from "./documento_encaminhamento.vue?vue&type=script&lang=js&"
export * from "./documento_encaminhamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468589fb",
  null
  
)

export default component.exports